// utils/htmlUtils.js
export const getContentExtract = (htmlContent, isFeatured = false) => {
    // Si estamos en el servidor (SSR) o en un entorno sin DOM
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return getContentExtractFallback(htmlContent, isFeatured);
    }

    // Si estamos en el navegador
    return getContentExtractBrowser(htmlContent, isFeatured);
};

const getContentExtractBrowser = (htmlContent, isFeatured) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    const contentElements = Array.from(tempDiv.children);
    let extractedElements = [];
    let paragraphCount = 0;

    for (const element of contentElements) {
        const tagName = element.tagName.toLowerCase();

        if (['img', 'video', 'iframe', 'picture'].includes(tagName)) {
            extractedElements.push(element.outerHTML);
        }
        else if (['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tagName)) {
            if (tagName === 'p') paragraphCount++;

            extractedElements.push(element.outerHTML);

            if (isFeatured && paragraphCount >= 4) break;
            if (!isFeatured && paragraphCount >= 1) break;
        }

        if (extractedElements.length >= (isFeatured ? 12 : 6)) break;
    }

    if (extractedElements.length === 0) {
        return getContentExtractFallback(htmlContent, isFeatured);
    }

    return extractedElements.join('') + '<p><em>...</em></p>';
};

const getContentExtractFallback = (htmlContent, isFeatured) => {
    // Extraer usando regex (funciona en servidor y cliente)
    const pMatches = htmlContent.match(/<p[^>]*>[\s\S]*?<\/p>/gi) || [];
    const imgMatches = htmlContent.match(/<img[^>]*>/gi) || [];
    const videoMatches = htmlContent.match(/<video[^>]*>[\s\S]*?<\/video>|<iframe[^>]*>[\s\S]*?<\/iframe>/gi) || [];

    let result = [];
    const maxParagraphs = isFeatured ? 4 : 1;

    // Añadir elementos multimedia primero
    result.push(...imgMatches.slice(0, 2));
    result.push(...videoMatches.slice(0, 2));

    // Añadir párrafos
    result.push(...pMatches.slice(0, maxParagraphs));

    if (result.length === 0) {
        // Fallback final: texto plano
        const text = htmlContent.replace(/<[^>]*>/g, '');
        return (isFeatured ? text.substring(0, 800) : text.substring(0, 300)) + '...';
    }

    return result.join('') + '<p><em>...</em></p>';
};